import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../queryKeys";
import { cdFetch } from "../api";
import { BusinessTrendData } from "../../services/interfaces/IBusinessCostTrend";
import { useAppSelector } from "../../services/redux/hooks/hooks";

const getQueryParams = (
  commodity: string | null,
  district: string[] | null,
  time_frame: string,
  email: string | null,
  base_sku?: string | null
) => {
  let qParams = "";
  if (commodity != null && commodity.length > 0) {
    qParams += `commodity=${JSON.stringify(commodity)}&`;
  }
  if (district != null && district.length > 0) {
    qParams += `plant_group=${JSON.stringify(district)}&`;
  }

  if (time_frame != null) {
    qParams += `time_frame=${JSON.stringify(time_frame)}&`;
  }
  if (email != null) {
    qParams += `email=${JSON.stringify(email)}&`;
  }
  if (base_sku) {
    qParams += `base_sku=${JSON.stringify(base_sku)}&`;
  }
  if (qParams.length > 0) {
    qParams = "?" + qParams.slice(0, -1);
  }

  return qParams;
};

export const useBusinessCostTrendData = (
  commodity: string | null,
  district: string[] | null,
  time_frame: string = "monthly",
  userEmail: string | null,
  base_sku: string | null
) => {
  const { data: res, isLoading } = useQuery({
    queryKey: [
      queryKeys.businessTrend,
      "data",
      commodity,
      district,
      time_frame,
      userEmail,
      base_sku,
    ],
    queryFn: () =>
      getBusinessCostData(commodity, district, time_frame, userEmail, base_sku),
    enabled:
      userEmail &&
      userEmail !== null &&
      userEmail !== undefined &&
      userEmail !== ""
        ? true
        : false,
  });

  const data: BusinessTrendData = { ...res?.data };
  return { data, isLoading };
};

const getBusinessCostData = (
  commodity: string | null,
  district: string[] | null,
  time_frame: string,
  userEmail: string | null,
  base_sku: string | null
) => {
  const queryParams = getQueryParams(
    commodity,
    district,
    time_frame,
    userEmail,
    base_sku
  );

  const res = cdFetch(`/getBusinessCostSettingTrendChartData${queryParams}`);
  return res;
};
